<template >
  <span>

    <v-toolbar dense
               fixed>
      <v-btn router
             flat
             to="/viewfreight"
             class="teal--text darken-2">Kangaruu</v-btn>
      <v-spacer></v-spacer>

      <v-btn class="teal--text darken-2"
             small
             router
             flat
             icon
             v-on:click="logout">
        <v-icon>exit_to_app</v-icon>
      </v-btn>

      <v-btn small
             flat
             icon
             router
             color="teal"
             @click.native="showHelp = true">
        <v-icon>help</v-icon>
      </v-btn>

    </v-toolbar>

    <v-layout wrap>
      <v-flex xs12
              sm6
              offset-sm3>
        <v-toolbar class="teal">
          <v-toolbar-title class="white--text">{{title}}</v-toolbar-title>
          <v-spacer>
          </v-spacer>
          <v-btn small
                 flat
                 icon
                 v-on:click.native="$router.push({ name: 'viewfreight' })"
                 color="white">
            <v-icon>keyboard_backspace</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card>
          <div class="google-maps">
            <iframe :src="googleUrl"
                    width="400"
                    height="300"
                    frameborder="0"
                    style="border:0"></iframe>
          </div>
          <v-divider></v-divider>

          <v-list two-line>

            <v-list-tile style="display: none">
              <v-list-tile-content>
                <v-list-tile-title>
                  Bill of Lading:
                  <v-icon @click.stop="showImage = true"
                          v-if="shipment.BOL">pageview</v-icon>
                </v-list-tile-title>
              </v-list-tile-content>

              <v-list-tile-action-text>
                <input accept="image/*, .pdf"
                       type="file"
                       ref="imageUpload"
                       @change="detectFiles($event.target.files)">
                <file-uploader :fileList="fileList"
                               :freightID="freightID"
                               v-on:bytes="changeBytes"
                               v-on:finished="uploadDone"></file-uploader>
              </v-list-tile-action-text>

            </v-list-tile>

          </v-list>

          <v-list two-line>
            <template v-for="(broker, key, index) in brokers">
              <v-list-tile :key="broker.id">
                <v-list-tile-content ripple
                                     @click="showBroker(broker.id)">
                  <v-list-tile-title>
                    <v-icon class="red--text darken-4"
                            v-if="broker.newMessage">fiber_new</v-icon>
                    <broker-name class="teal--text daarken-4"
                                 :brokerID="broker.id"></broker-name>
                  </v-list-tile-title>
                  <v-list-tile-sub-title class="orange--text daarken-4">
                    {{broker.quote}}
                  </v-list-tile-sub-title>
                  <v-list-tile-sub-title class="blue--text caption">
                    {{calculateRate(broker.quote, shipment.Miles)}}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action-text v-if="broker.selected">Tendered</v-list-tile-action-text>
                <v-list-tile-action-text v-if="!broker.selected">Tender</v-list-tile-action-text>
                <v-list-tile-action @click="selectBrokers(broker.id, broker.selected)">
                  <v-switch color="green"
                            v-model="broker.selected">
                  </v-switch>
                </v-list-tile-action>
              </v-list-tile>

              <v-divider :key="index"></v-divider>
            </template>
          </v-list>
          <v-slide-y-transition>
            <v-card-text v-show="showWaybill">
              <waybill :freightID="shipmentID"
                       :isBroker="false"
                       :brokerID="brokerID"
                       v-on:closeWaybill="showWaybill = false"
                       v-on:printWaybill="print()"
                       id="my-node">
              </waybill>
            </v-card-text>
          </v-slide-y-transition>

          <v-dialog v-model="showImage"
                    max-width="200">
            <v-card v-on:closeImage="showImage=false">
              <v-card-title>Available Images</v-card-title>
              <v-list>
                <v-list-tile>
                  <div style="overflow: scroll; -webkit-overflow-scrolling: touch; width: 300px;">
                    <iframe :src="imageURL"
                            style="width: 600px;">Oops! an error has occurred.</iframe>
                  </div>

                </v-list-tile>
              </v-list>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon
                       v-on:click="showImage=false">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="brokerDialog"
                    max-width="600">

            <add-brokers v-on:closeBroker="brokerDialog=false"
                         :freightID="shipmentID"></add-brokers>

          </v-dialog>

          <v-dialog v-model="editor"
                    max-width="600">
            <v-card color="grey lighten-4"
                    flat>
              <v-card-text>
                <v-text-field name="shipping"
                              label="Shipping Instructions"
                              autofocus=""
                              v-model="instructions"
                              textarea></v-text-field>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn flat
                       small
                       color="teal"
                       @click.native="sendInstructions(true)">
                  Send
                </v-btn>
                <v-btn flat
                       small
                       color="teal"
                       @click.native="sendInstructions(false)">
                  Save
                </v-btn>
                <v-btn flat
                       small
                       color="teal"
                       @click.native="editor = false">
                  Cancel
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-card-actions>
            <v-progress-circular v-if="uploading"
                                 :value="bytes"
                                 color="red"></v-progress-circular>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <v-btn icon
                     small
                     flat
                     slot="activator"
                     color="teal"
                     @click.native="editor=true">
                <v-icon>list_alt</v-icon>
              </v-btn>
              <span>Create Shipping Instructions</span>
            </v-tooltip>

            <v-tooltip bottom>
              <v-btn icon
                     small
                     flat
                     slot="activator"
                     color="teal"
                     @click.native="warnDialog=true">
                <v-icon>done</v-icon>
              </v-btn>
              <span>Finalize Shipment</span>
            </v-tooltip>

            <v-tooltip bottom>
              <v-btn icon
                     small
                     flat
                     slot="activator"
                     color="teal"
                     @click.native="brokerDialog=true">
                <v-icon>account_circle</v-icon>
              </v-btn>
              <span>Add A Broker</span>
            </v-tooltip>

            <v-tooltip bottom>
              <v-btn v-if="!shipment.BOL"
                     icon
                     small
                     flat
                     slot="activator"
                     @click="onPickFile()">
                <v-icon color="teal">photo_camera</v-icon>
              </v-btn>
              <span>Upload Bill Of Lading</span>
            </v-tooltip>

            <v-tooltip bottom>
              <v-btn v-if="shipment.BOL"
                     icon
                     small
                     flat
                     slot="activator"
                     v-on:click.native="$router.push({ name: 'viewimages', params: { freightID: freightID, imageURL: imageURL, isBroker: false, imageName: shipment.File } })">
                <v-icon color="teal">attach_file</v-icon>
              </v-btn>
              <span>View Bill Of Lading</span>
            </v-tooltip>

            <v-tooltip bottom>
              <v-btn icon
                     small
                     flat
                     slot="activator"
                     @click.stop="showWaybill = true">
                <v-icon color="teal">assignment</v-icon>
              </v-btn>
              <span>View Shipment Details</span>
            </v-tooltip>

          </v-card-actions>

        </v-card>
      </v-flex>

      <v-layout row
                justify-center>
        <v-dialog v-model="warnDialog"
                  persistent
                  max-width="290">
          <v-card>
            <v-card-title class="headline">Finalize this Shipment?</v-card-title>
            <v-card-text>Finalizing a shipment will remove it from your and your BROKERS active shipments. Shipments should be finalized after delivery.</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1"
                     flat
                     @click.native="warnDialog = false">Disagree</v-btn>
              <v-btn color="green darken-1"
                     flat
                     @click.native="removeShipment()">Agree</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <v-snackbar :timeout="4000"
                  v-model="snackbar">
        File Uploaded!
        <v-btn dark
               flat
               @click.native="snackbar = false">Close</v-btn>
      </v-snackbar>

    </v-layout>

    <v-dialog v-model="showHelp">
      <v-card>
        <help></help>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey"
                 flat
                 outline
                 @click.native="showHelp = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </span>
</template>

<script>
import db from './fireBaseInit'
import waybill from './WayBill'
import brokerName from './BrokerName'
import firebase from 'firebase'
import addBrokers from './AddBrokers'
import fileUploader from './FileUploader'
import moment from 'moment'
import domtoimage from 'dom-to-image'
import printJS from 'print-js'
import help from '@/components/DetailHelp'

export default {
  name: 'freightdetail',
  props: ['shipmentID'],
  components: { waybill, brokerName, addBrokers, fileUploader, help },
  data () {
    return {
      shipment: {},
      googleUrl: null,
      title: null,
      brokers: [],
      warnDialog: false,
      brokerDialog: false,
      user: {},
      freightID: '',
      showImage: false,
      imageURL: '',
      fileList: [],
      uploading: false,
      bytes: 0,
      snackbar: false,
      editor: false,
      instructions: '',
      brokerID: '',
      showHelp: false,
      showWaybill: false
    }
  },
  watch: {
    brokers: function () {
      this.getSelectedBroker()
    }
  },
  mounted: function () {
    this.$bind('shipment', db.collection('freight').doc(this.shipmentID))
      .then((doc) => {
        if (doc.Shipper === firebase.auth().currentUser.uid) {
          this.freightID = this.shipmentID
          this.getMap()
          this.clearMessageFlag()
          this.imageURL = this.shipment.BOL
          this.instructions = this.shipment.Instructions
          this.getSelectedBroker()
        } else {
          alert('Cannot Access this Shipment')
          this.shipment = 'Invalid'
          this.freightID = 'Invalid'
        }
      })
      .catch((error) => {
        console.log('error in loading: ', error)
      })
  },
  methods: {
    print: function () {
      printJS({ printable: 'my-node', type: 'html', documentTitle: 'Kangaruu - Shipping Instructions' })
    },
    changeBytes: function (bytes) {
      console.log(bytes)
      this.bytes = bytes
    },
    uploadDone: function () {
      this.uploading = false
      this.snackbar = true
    },
    calculateRate: function (quote, miles) {
      var nQuote = 0
      var nMiles = 0
      if (quote != null) {
        nQuote = parseFloat(quote.replace(/[$,]+/g, ''))
      }
      if (miles != null) {
        nMiles = parseFloat(miles.replace(/[$,]+/g, ''))
      }
      // console.log(quote, nQuote, nMiles)
      var currentRate = 2.75
      var avgRate = currentRate * nMiles
      var rateDiff = avgRate - nQuote
      // console.log(rateDiff)
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      })
      var rateDiffString = formatter.format(rateDiff)
      // console.log(avgRate, rateDiff, nQuote)
      if (avgRate >= nQuote && nQuote > 0 && nMiles > 0) {
        return `${rateDiffString} below market rate.`
      } else if (avgRate < nQuote && nQuote > 0 && nMiles > 0) {
        return `${rateDiffString} above market rate.`
      }
    },
    getMap: function () {
      this.title = 'Shipment: ' + this.shipment.Reference
      console.log(this.shipment.Delivery)
      if (typeof this.shipment !== 'undefined' && this.shipment) {
        var start = this.shipment.Pickup[0]
        var end = this.shipment.Delivery[this.shipment.Delivery.length - 1]
        var points = ''
        for (let i = 1; i < this.shipment.Pickup.length; i++) {
          let str = this.shipment.Pickup[i]
          points = points + str.replace(/ /g, '+') + '| '
        }
        for (let i = 0; i < this.shipment.Delivery.length; i++) {
          let str = this.shipment.Delivery[i]
          points = points + str.replace(/ /g, '+') + '| '
        }
        points = points.substring(0, points.length - 2)

        this.googleUrl = `https://www.google.com/maps/embed/v1/directions?key=AIzaSyCw3FKI8Eh1SY6rfwJkba1LL3Aetx9RrvI&origin=${start}&destination=${end}&waypoints=${points}`
      }
    },
    onPickFile () {
      this.$refs.imageUpload.click()
    },
    detectFiles (fileList) {
      this.uploading = true
      Array.from(Array(fileList.length).keys()).map(x => {
        this.fileList = fileList[x]
      })
    },
    removeShipment: function () {
      this.warnDialog = false
      db.collection('freight').doc(this.freightID).update({ isActive: false })
      // db.collection('conversations').doc(this.$route.params.id).delete()
      this.$router.replace({ path: '/viewfreight' })
    },
    getSelectedBroker () {
      for (var brokerKey in this.shipment.brokers) {
        this.loadBrokerData(brokerKey)
      }
    },
    loadBrokerData (brokerKey) {
      db.collection('conversations').doc(this.freightID).collection('brokers').doc(brokerKey).get().then((snap) => {
        if (snap.data().selected) {
          this.brokerID = brokerKey
          console.log('selected Broker:', this.brokerID)
        }
      })
    },
    selectBrokers: function (brokerID, selected) {
      let message = {}
      let update = {}
      console.log(brokerID, selected)
      for (var brokerKey in this.shipment.brokers) {
        console.log(brokerKey)
        if (brokerKey === brokerID && selected) {
          this.brokerID = brokerKey
          // send a push
          db.collection('users').doc(brokerKey).get().then((snap) => {
            if (snap.data().sendPush) {
              db.collection('push').add({ sendTo: `${this.brokerID}` })
            }
          })
          update['selected'] = true
          db.collection('conversations').doc(this.freightID).collection('brokers').doc(brokerKey).update(update)
          message['message'] = 'Ready to ship, please arrange a pickup.'
          message['sender'] = firebase.auth().currentUser.uid
          message['created'] = moment().unix()
          db.collection('conversations').doc(this.freightID).collection('brokers').doc(brokerKey).collection('messages').add(message)
        } else {
          this.revokeFreight(brokerKey)
          update['selected'] = false
          db.collection('conversations').doc(this.freightID).collection('brokers').doc(brokerKey).update(update)
        }
      }
      // update freight Record
      var brokerList = {}
      var shipment = {}
      for (brokerKey in this.shipment.brokers) {
        if (brokerKey === brokerID) {
          brokerList[brokerKey] = selected
        } else {
          brokerList[brokerKey] = false
        }
      }
      shipment['isSelected'] = brokerList
      db.collection('freight').doc(this.freightID).update(shipment)
    },
    revokeFreight: function (brokerID) {
      var message = {}
      console.log('they are the smame')
      db.collection('freight').doc(this.freightID).get().then((snap) => {
        if (snap.data().isSelected) {
          console.log(brokerID, snap.data().isSelected[brokerID])
          if (snap.data().isSelected[brokerID]) {
            message['message'] = 'Tender Revoked'
            message['sender'] = firebase.auth().currentUser.uid
            message['created'] = moment().unix()
            console.log('revoked')
            db.collection('conversations').doc(this.freightID).collection('brokers').doc(brokerID).collection('messages').add(message)
          }
        }
      })
    },
    sendInstructions (email) {
      var id = this.freightID
      var shipment = {}
      var vm = this
      shipment['Instructions'] = this.instructions
      if (this.instructions) {
        db.collection('freight').doc(this.freightID).update(shipment).then((snap) => {
          this.editor = false
          // Send summary email
          if (email) {
            vm.showWaybill = true
            vm.$nextTick(function () {
              var node = document.getElementById('my-node')
              domtoimage.toBlob(node)
                .then(function (dataUrl) {
                  var storageRef = firebase.storage().ref()
                  var uploadTask = storageRef.child(id + '/' + 'instructions.png').put(dataUrl)

                  uploadTask.on('state_changed', function (snapshot) {
                    // Observe state change events such as progress, pause, and resume
                    // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                    this.progressUpload = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                    console.log('Upload is ' + this.progressUpload + '% done')
                    switch (snapshot.state) {
                      case firebase.storage.TaskState.PAUSED: // or 'paused'
                        console.log('Upload is paused')
                        break
                      case firebase.storage.TaskState.RUNNING: // or 'running'
                        console.log('Upload is running')
                        break
                    }
                  }, function (error) {
                    // Handle unsuccessful uploads
                    console.log(error)
                  }, function () {
                    // Handle successful uploads on complete
                    console.log(uploadTask.snapshot)
                    vm.showWaybill = false
                    // Ok Now send Receipts
                    if (vm.user.sendReceipt) {
                      db.collection('receipt').add({ sendTo: `${vm.user.email}`, sendDoc: `${vm.freightID}` })
                      console.log('send Receipt Sender')
                    }
                    var receipt = {}
                    var push = {}
                    console.log(vm.brokerID)
                    db.collection('users').doc(vm.brokerID).get().then((snap) => {
                      if (snap.data().sendReceipt) {
                        receipt['sendTo'] = snap.data().email
                        receipt['sendDoc'] = vm.freightID
                        db.collection('receipt').add(receipt)
                        console.log('send Receipt Broker')
                      }
                      if (snap.data().sendPush) {
                        push['sendTo'] = snap.id
                        db.collection('push').add(push)
                        console.log('send Push Broker')
                      }
                    })
                  })
                })
            })
          }
        })
      }
    },
    downLoadFile () {
      var fileName = this.shipment.File
      var xhr = new XMLHttpRequest()
      xhr.responseType = 'blob'
      xhr.onload = function (event) {
        var blob = new Blob([xhr.response], { type: 'image/png' })
        console.log(xhr.response)
        let a = document.createElement('a')
        a.style = 'display: none'
        document.body.appendChild(a)
        // Create a DOMString representing the blob
        // and point the link element towards it
        let url = window.URL.createObjectURL(blob)
        a.href = url
        a.download = fileName
        // programatically click the link to trigger the download
        a.click()
        // release the reference to the file by revoking the Object URL
        window.URL.revokeObjectURL(url)
      }
      xhr.open('GET', this.shipment.BOL)
      xhr.send()
    },
    showBroker: function (brokerID) {
      // this.$router.push('/broker' + '/' + brokerID)
      this.$router.push({ name: 'brokerdetail', params: { brokerID: brokerID, freightID: this.freightID } })
    },
    logout: function () {
      firebase.auth().signOut().then(() => {
        this.$router.replace('/')
      })
    },
    clearMessageFlag: function () {
      var userList = {}
      userList = this.shipment.newMessages
      var messages = {}
      userList[this.shipment.Shipper] = false
      messages['newMessages'] = userList
      db.collection('freight').doc(this.freightID).update(messages)
    }
  },
  firestore () {
    return {
      brokers: db.collection('conversations').doc(this.shipmentID).collection('brokers')
        .where('isActive', '==', true),
      user: db.collection('users').doc(firebase.auth().currentUser.uid)
      // add this for security .where('shipper', '==', 'firebase.auth().currentUser.uid')
    }
  }
}
</script>

<style>
.google-maps {
  position: relative;
  padding-bottom: 75%;
  height: 0;
  overflow: hidden;
}
.google-maps iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100% !important;
  height: 100% !important;
}

/* Shipping List */
#sList {
  font-family: 'Courier New', Courier, monospace;
}
</style>




// WEBPACK FOOTER //
// src/components/FreightDetail.vue